
const publistHead = [
  {
    title: '序号',
    slot: 'sort',
    width: 60,
    fixed: 'left'
  }
];
const publistFoot = [
  {
    title: '平台',
    key: 'platformName',
    width:100
  },
  {
    title: 'SPU',
    key: 'spuCode',
    width:120
  },
  {
    title: 'SKU',
    key: 'skuCode',
    width:120
  },
  {
    title: '设置配置',
    key: 'totalAllocation',
    width:100
  },
  {
    title: '计算已使用配额',
    key: 'usedAllocation',
    width:130
  },
  {
    title: '当前剩余配额',
    key: 'remainderAllocation',
    width:120
  },
  {
    title: '冻结配额',
    key: 'frozenAllocation',
    width:100
  },
  {
    title: '配额类型',
    key: 'allocationType',
    render: (h, params) => {
        // 0-金额，1-数量
        let s = params.row.status;
        let t = s==1?'数量':'金额';
        return h('span', t);
    },
    width:100
  },
  {
    title: '配额月份',
    key: 'yearMonth',
    width:100
  },
  {
    title: '创建时间',
    key: 'createtime',
    width:200
  },
  {
    title: '更新时间',
    key: 'updatetime',
    width:200
  },
  {
    title: '状态',
    key: 'status',
    render: (h, params) => {
        // 0-生效，1-停用，2-删除
        let s = params.row.status;
        let t = s==2?'删除':s==1?'停用':'生效';
        return h('span', t);
    },
    width:100,
    fixed: 'right'
  },
];

const columns = {
  province:[
    ...publistHead,
    {
      title: '配额省份',
      key: 'provinceName',
      width:100
    },
    ...publistFoot
  ],
  retailer:[
    ...publistHead,
    {
      title: '门店',
      key: 'retailerCode',
      width:150
    },
    ...publistFoot
  ],
  retailerGroup:[
    ...publistHead,
    {
      title: '客户集团',
      key: 'gradeGroupCode',
      width:100
    },
    ...publistFoot
  ],
  shipTo:[
    ...publistHead,
    {
      title: '配额等级集团',
      key: 'retailerGroupCode',
      width:150
    },
    {
      title: '送达方编码',
      key: 'shipToCode',
      width:100
    },
    ...publistFoot
  ],
};

  export default columns;



// WEBPACK FOOTER //
// ./src/views/quota/columns.js